/* eslint-disable @reatom/unit-naming-rule */
import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'use-memo-one'

import { Switch } from '@blade/ui-kit'
import { CurrencyListItem } from '@root/entities/currency/ui/currency-list-item'

import { reatomToggleWalletAsset } from '../../atoms'

import type { CurrencyModel } from '@root/entities/currency'
import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
  currency: CurrencyModel
}

export const WalletAssetToggleItem: React.FC<Props> = ({
  wallet,
  currency,
}) => {
  const toggleModel = useMemo(
    () => reatomToggleWalletAsset({ wallet, currency }),
    [wallet, currency],
  )
  const [asset] = useAtom((ctx) => {
    const asset = ctx.spy(wallet.assetsByCurrency)[currency.address]
    return asset
  })
  const [requestState] = useAtom(toggleModel)
  const [checked] = useAtom(
    (ctx) => {
      if (!asset) {
        return false
      }
      return !ctx.spy(asset.hidden)
    },
    [asset],
  )

  const toggle = useAction(toggleModel.execute)

  return (
    <CurrencyListItem
      key={currency.address}
      pair={asset?.pair}
      currency={currency}
      endContent={
        <Switch
          size="m"
          disabled={requestState.loading}
          checked={checked}
          onCheckedChange={() => {
            toggle()
          }}
        />
      }
    />
  )
}
